import { LOCALES } from '~/utils/const'

export default function validateLocale(locale: string) {
  const localeKey = LOCALES.find((validLocale) => validLocale === locale)
  if (localeKey) return localeKey
  console.log(`${locale} is an invalid locale, defaulting to 'en'.`)
  return 'en'
}
